// Credit band keys match finance-inputs.ts and dashboard.ts exactly.
// "excellent_740+" uses a literal plus sign.
export const CREDIT_BAND_LABELS: Record<string, string> = {
  "excellent_740+": "Excellent (740+)",
  good_700_739: "Good (700-739)",
  fair_660_699: "Fair (660-699)",
  below_660: "Below 660",
};

export const CREDIT_BAND_ITEMS = Object.entries(CREDIT_BAND_LABELS).map(
  ([value, label]) => ({ label, value }),
);
